<template>
  <div class="premium">
    <el-button class="btn-right" type="primary" @click="onBatch" v-if="isBatch">
      批量设置销售溢价
    </el-button>
    <div class="table-link" @click="onOpenDialog" v-else>设置销售溢价</div>
    <el-dialog v-if="dialogVisible" title="设置销售溢价" :visible.sync="dialogVisible" modal-append-to-body width="1000px"
      append-to-body class="dialog">
      <!-- <div class="premium-tip">
        <div class="color-pink">
          <div><i class="el-icon-info"></i>  为维护平台售价平稳，春节期间(2024-02-10 0:00至2024-02-18 23:59)，达人溢价浮动仅支持在-3%~3%之间调整。春节档期过后恢复-6%~6%。</div>

        </div>
      </div> -->
      <div class="table-num premium-bottom" v-if="isBatch">
        已选中{{ ids.length }}个
      </div>
      <div class="table-tip premium-space">在平台定价的基础上</div>
      <el-form inline label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item prop="type">
          <el-radio-group v-model="form.type">
            <div class="premium-radio">
              <el-radio :label="1">加价 </el-radio>
              <el-form-item prop="addPriceRate">
                <el-input v-model="form.addPriceRate" placeholder="请输入">
                  <template slot="append">%</template></el-input>
                <span class="color-gray">输入范围：0~6</span>
              </el-form-item>
            </div>
            <div class="premium-radio">
              <el-radio :label="2">让利 </el-radio>
              <el-form-item prop="cutPriceRate">
                <el-input v-model="form.cutPriceRate" placeholder="请输入">
                  <template slot="append">%</template></el-input>
                <span class="color-gray">输入范围：0~6</span>
              </el-form-item>
            </div>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="premium-tip">

        <div class="premium-bottom">
          <div><i class="el-icon-info"></i>温馨提示：</div>
          <div class="color-pink">
            1、加价/让利后，平台将按加价/让利前的售价给您结算佣金，加价/让利产生的额外收益或亏损，将由您自己承担。
          </div>
          <div>
            2、加价/让利不影响达人佣金的结算，还是按您设置的分佣比例 x
            达人营业额。
          </div>
          <div>3、设置成功后，购票端售价将立即改变。</div>
          <div>4、销售溢价仅对特惠购票的售价生效，快出购票的售价不生效。</div>
        </div>

        <div class="premium-bottom color-gray">
          <div>示例：</div>
          <div>
            1、某某影票市场价：100元/张， 平台折扣价：90元/张（折扣率90%），设置加价2%；实际售价=市场价 x (平台折扣+溢价比例) = 100x(90%+2%)=92元
          </div>
          <div>
            2、某某影票市场价：100元/张， 平台折扣价：90元/张（折扣率90%），设置让利3%；实际售价=市场价 x (平台折扣-溢价比例) = 100x(90%-3%)=87元
          </div>
          <div>假设代理分佣比例5%，达人3%；加价、不加价及不加价不让利的情况下对应提成如下表。</div>
          <el-table size="mini" :data="tableData" style="margin-top:24px; width: 100%">
            <el-table-column prop="commission" label="" width="180">
              <template slot-scope="{ row,$index }">
                <span :style="{ color: $index === 2 ? '#FF4F76' : '#333' }">
                  {{ row.commission }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="model1" label="加价/让利=0" width="180">
              <template slot-scope="{ row ,$index}">
                <span :style="{ color: $index === 2 ? '#FF4F76' : '#333' }">
                  {{ row.model1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="model2" label="加价=2%">
              <template slot-scope="{ row ,$index }">
                <span :style="{ color: $index === 2 ? '#FF4F76' : '#333' }">
                  {{ row.model2 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="model3" label="让利=2%">
              <template slot-scope="{ row , $index }">
                <span :style="{ color: $index === 2 ? '#FF4F76' : '#333' }">
                  {{ row.model3 }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();
import { matchFractionalPart1 } from "@/utils/regExp";
const formParams = {
  type: 1, // 定价类型
  addPriceRate: "", // 销售溢价
  cutPriceRate: "", // 让利
};
export default {
  props: {
    ids: {
      // ids的集合
      type: Array,
      default: () => [],
    },
    isBatch: {
      // 是否是批量操作
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      form: Object.assign({}, formParams),
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
      tableData: [{
        commission: '订单佣金',
        model1: '90*5%=4.5',
        model2: '90*5%+100*2%=6.5',
        model3: '90*5%-100*2%=2.5'
      }, {
        commission: '达人佣金',
        model1: '90*3%=2.7',
        model2: '(90+100*2%)* 3%=2.76',
        model3: '(90-100*2%)* 3%=1.76'
      }, {
        commission: '您的实际佣金',
        model1: '4.5-2.7=1.8',
        model2: '6.5-2.76=3.74',
        model3: '2.5-1.76=0.74'
      },]
    };
  },
  computed: {
    rules() {
      // 是否为加价类型
      const isAddType = this.form.type === 1;
      return {
        addPriceRate: [
          {
            required: isAddType,
            message: "请输入加价的销售溢价",
            trigger: ["blur", "change"],
          },
          {
            required: isAddType,
            pattern: matchFractionalPart1,
            message: "请输入数字，最多保留一位小数 ",
            trigger: ["blur", "change"],
          },
          {
            required: isAddType,
            validator: (rule, value, callback) => {
              if (value > 6) {
                callback(new Error("请输入小于等于6的加价的销售溢价"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        cutPriceRate: [
          {
            required: !isAddType,
            message: "请输入让利的销售溢价",
            trigger: ["blur", "change"],
          },
          {
            required: !isAddType,
            pattern: matchFractionalPart1,
            message: "请输入数字，最多保留一位小数 ",
            trigger: ["blur", "change"],
          },
          {
            required: !isAddType,
            validator: (rule, value, callback) => {
              if (value > 6) {
                callback(new Error("请输入小于等于6的让利的销售溢价"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      };
    },
  },
  methods: {
    // 打开弹框
    onOpenDialog() {
      this.form.type = this.row.priceRateType;
      this.form.addPriceRate = this.row.addPriceRate;
      this.form.cutPriceRate = this.row.cutPriceRate;
      this.dialogVisible = true;
    },
    // 批量操作
    onBatch() {
      if (this.ids && this.ids.length) {
        this.dialogVisible = true;
      } else {
        this.$message.error("请先选择达人");
      }
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 确定
    onSure() {

      if (!this.form.type) {
        this.$message.error('请先选择加价或者让利');
        return

      }
      if (this.ids && this.ids.length) {

        this.saveLoading = true;
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            const params = { type: this.form.type, ids: this.ids.join(",") };
            params.rate =
              params.type === 1
                ? this.form.addPriceRate
                : this.form.cutPriceRate;
            const data = await DouYinModel.setMasterpremium(params).finally(
              () => {
                this.saveLoading = false;
              }
            );
            if (data.data.code === 200) {
              this.onCancel();
              this.$emit("refresh");
              this.$message.success(data.data.message);
            } else {
              this.$message.error(data.data.message);
            }
          } else {
            this.saveLoading = false;
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form {
  .el-input {
    width: 213px;
  }
}


.premium {

  &-space {
    margin: 12px 0 24px;
  }

  &-radio {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }



  &-tip {
    background: #FAFAFA;
    padding: 8px;

  }

  &-bottom {
    margin-bottom: 20px;
  }

  :deep(.el-form-item) {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/distribution/SetSalesPremium.vue